<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Association Overview</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }} >  {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
        </div>
      </div> 
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''" 
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <!-- 协会简介 -->
          <div class="survey-module-right-action" v-show="menu_id==1">
            <div v-if="menu_action1" v-html="menu_action1"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
          <!-- 协会章程 -->
          <div class="survey-module-right-action" v-show="menu_id==2">
            <div v-if="menu_action2" v-html="menu_action2"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
          <!-- 组织机构 -->
          <div class="survey-module-right-action" v-show="menu_id==3">
            <img :src="$baseUrl+menu_action3.url" alt="">
            <div class="organization-item" v-for="(item,index) in menu_action3.context" :key="index">
              <div class="organization-item-title align-center">
                <div class="organization-item-title-dot"></div>
                <span>{{ item.title }}</span>
              </div>
              <div class="organization-item-action">
                <div class="organization-item-action-item">{{ item.value }}</div>
              </div>
            </div>
          </div>
          <!-- 理事会 -->
          <div class="survey-module-right-action" v-show="menu_id==4">
            <div class="council-title justify-center align-center">
              {{$wangzhan.name=='安徽'?'安徽省心理学会':($wangzhan.name+'心理咨询协会')}}组织机构图
            </div>
            <table border>
              <tr>
                <th>ID</th>
                <th>姓名</th>
                <th>性别</th>
                <th>民族</th>
                <th>年龄</th>
                <th>单位</th>
                <th>职务/职称</th>
                <th>职务</th>
              </tr>
              <tr v-for="(item,index) in menu_action4" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{  item.name }}</td>
                <td>{{  item.sex }}</td>
                <td>{{  item.nation }}</td>
                <td>{{ item.age }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.duties }}</td>
                <td>{{ item.appointment }}</td>
              </tr>
            </table>
            <div class="pagination-content justify-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getItem,getCouncil,getDepartment} from '@/api/xhgk'
export default {
  data(){
    return{
      menu:{
        title:this.$wangzhan.name=='安徽'?'学会概况':'协会概况',
        list:[
          {name:this.$wangzhan.name=='安徽'?'学会简介':'协会简介',id:'1'},
          {name:this.$wangzhan.name=='安徽'?'学会章程':'协会章程',id:'2'},
          {name:'组织机构',id:'3'},
          {name:'理事会',id:'4'},
        ]
      },
      menu_id:this.$route.query.id,
      menu_action1:'',
      menu_action2:'',
      menu_action3:{},
      menu_action4:[],
      queryParams:{
        pageNum: 1,
        pageSize: 20,
      },
      total:0,
    }
  },
  created(){
    this.getRich('synopsis')
    this.getRich('constitution')
    this.getZuZhi()
    this.getListFun()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getListFun()
    },
    menuFun(id){
      this.menu_id = id
    },
    getRich(type){
      getItem({ type })
        .then((res) => {
          if(type=='synopsis'){
            this.menu_action1 = res.data.content;
            this.menu_action1 = this.menu_action1.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
            this.menu_action1 = this.menu_action1.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
          }else{
            this.menu_action2 = res.data.content;
            this.menu_action2 = this.menu_action2.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
            this.menu_action2 = this.menu_action2.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
          }
        })
        .finally(() => {});
    },
    getListFun(){
      getCouncil(this.queryParams)
      .then((res) => {
        this.menu_action4 = res.data.list
        this.total = res.data.total
      })
    },
    getZuZhi(){
      getDepartment().then((res) => {
        this.menu_action3 = res.data
      })
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>

</style>
